// src/domains/core/dashboard/components/widgets/llm/LLMServicesWidget.tsx

import { MessageSquare } from "lucide-react";
import { type FC } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Grid } from "@/components/ui";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * LLMServicesWidget - Quick Access zu LLM Services
 *
 * @returns {JSX.Element} LLM services widget component
 *
 */
export const LLMServicesWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.LLM_SERVICES);
  const navigate = useNavigate();

  return (
    <WidgetContainer
      description="AI chat access"
      icon={<MessageSquare className="w-5 h-5" />}
      size={config?.size ?? "small"}
      title="LLM Services"
      widgetId={WIDGET_IDS.LLM_SERVICES}
    >
      <Grid cols={{ sm: 1 }} gap={2}>
        <Button
          className="w-full"
          onClick={() => {
            // Reason: navigate() returns void, but ESLint treats it as Promise
            // eslint-disable-next-line sonarjs/void-use -- Reason: navigate() returns void, not Promise
            void navigate("/llm/chatgpt");
          }}
          size="sm"
          variant="outline"
        >
          ChatGPT
        </Button>
        <Button
          className="w-full"
          onClick={() => {
            // Reason: navigate() returns void, but ESLint treats it as Promise
            // eslint-disable-next-line sonarjs/void-use -- Reason: navigate() returns void, not Promise
            void navigate("/llm/ollama");
          }}
          size="sm"
          variant="outline"
        >
          Ollama
        </Button>
      </Grid>
    </WidgetContainer>
  );
};
